import Vue from 'vue';
import router from 'Router';
import { ClosedByUserError } from 'Classes';

function getAppRootElement() {
  return document.getElementById('app');
}

function mountModal(modalInstance) {
  const rootElement = getAppRootElement();
  rootElement.appendChild(modalInstance.$el);
}

function destroyModal(modalInstance) {
  // TODO: refactor this to avoid such dependencies
  // IDEA: pass value as prop to modal and control it from here. Maybe close modal on user click close button
  // To have close animation add 1 sec to wait until animation ends
  modalInstance.closeConfirmModal?.();
  // then destroy component
  setTimeout(() => {
    modalInstance.$destroy();
    modalInstance.$el.remove();
  }, 1000);
}

/**
 *
 * @param ModalComponent - vue component of modal.
 *  Expected to have BaseModal or BaseConfirmModal as root element.
 *  Expected to have closeConfirmModal method to have animation on close
 * @param props
 * @param options
 * @param options.ignoreErrorOnUserClose {Boolean} - is not to throw error on user close modal
 * @param options {true} - same as ignoreErrorOnUserClose = true
 * @returns {Promise}
 */
export function openIndependentModal(ModalComponent, props = {}, options = {}) {
  return new Promise((resolve, reject) => {
    const ModalClass = Vue.extend(ModalComponent);
    const modalInstance = new ModalClass({
      router,
      propsData: {
        value: true,
        ...props,
      },
    }).$mount();

    mountModal(modalInstance);

    modalInstance.$on('cancel', () => {
      // Do not true error if ignoreErrorOnUserClose is true in options or options is Boolean true
      if (options.ignoreErrorOnUserClose || options === true) resolve();
      // Otherwise throw error
      else reject(new ClosedByUserError());
      destroyModal(modalInstance);
    });

    modalInstance.$on('success', (value) => {
      resolve(value);
      destroyModal(modalInstance);
    });
  });
}
